import React from 'react';
import Geosuggest from 'react-geosuggest';
import styled from 'styled-components';
import MarkerIcon from './marker';

const ValidationText = styled.p`
  padding-top: 0.5em !important;
  padding-left: 1em !important;
`;

const MobileSearch = styled(Geosuggest)`
  ul {
    display: none;
  }
`;

export const MobileLocationSearchInput = props => (
  <div className='field'>
    <div className='control has-icons-left'>
      <MobileSearch
        isOpen={false}
        resetBoundsOnResize={true}
        layerTypes={['TrafficLayer', 'TransitLayer']}
        initialValue={props.initialValue}
        autoActivateFirstSuggest={false}
        country={['ZA']}
        placeholder={'Enter a new address'}
        autoComplete='on'
        location={props.google}
        radius={'20'}
        minLength={3}
        onChange={value => props.onChange(value)}
        onUpdateSuggests={suggest => props.onUpdateSuggests(suggest)}
        autoFocus={false}
        tabIndex={1}
        inputClassName='input is-large custom-input location-input-padding'
        {...props.input}
      />
      <span className='icon is-small is-left location-input-icon-padding has-text-dark'>
        <MarkerIcon />
      </span>
    </div>
  </div>
);

export const LocationSearchInput = props => (
  <div className='field is-grouped'>
    <div className='control is-expanded has-icons-left'>
      <Geosuggest
        isOpen={false}
        resetBoundsOnResize={true}
        layerTypes={['TrafficLayer', 'TransitLayer']}
        initialValue={props.initialValue}
        autoActivateFirstSuggest={false}
        country={['ZA']}
        placeholder={'Search your location or enter a delivery address'}
        autoComplete='on'
        location={props.google}
        radius={'20'}
        minLength={3}
        onSuggestSelect={props.onSuggestSelect}
        autoFocus={false}
        tabIndex={1}
        inputClassName='input is-large custom-input location-input-padding'
        getSuggestLabel={suggest => suggest.description}
        {...props.input}
      />
      <span className='icon is-small is-left location-input-icon-padding has-text-dark'>
        <MarkerIcon />
      </span>
    </div>
  </div>
);

export default (field) => {
  const { experror, ...props } = field;
  return (
    <div className='field'>
      <label className='label'>{field.label}</label>
      <div className='control'>
        <Geosuggest
          isOpen={true}
          resetBoundsOnResize={true}
          layerTypes={['TrafficLayer', 'TransitLayer']}
          initialValue={props.initialValue}
          autoActivateFirstSuggest={true}
          country={['ZA']}
          placeholder={props.placeholder ? props.placeholder : 'Where can we deliver?'}
          autoComplete='on'
          location={props.google}
          radius={'20'}
          minLength={3}
          onSuggestSelect={props.onSuggestSelect}
          queryDelay={250}
          autoFocus={props.autoFocus}
          tabIndex={props.tabIndex}
          inputClassName='input  custom-input is-large'
          {...props.input}
        />
      </div>
      {(field.meta.touched && field.meta.error && !field.meta.active) &&
        <ValidationText className='help is-danger'>{field.meta.error}</ValidationText>
      }
    </div>
  );
};
